<!-- Root: flex column so content scrolls and footer stays visible -->
<div class="inner-mat-dialog flex justify-between content-stretch items-stretch flex-col">

  <div>
    <h1 mat-dialog-title>
      <div class="flex justify-start content-center items-center flex-row">
        <div class="flex flex-row justify-start content-stretch items-stretch h-full basis-1/2">
          Drug Validation Wizard
        </div>
        <div class="flex flex-row justify-end content-stretch items-stretch h-full basis-1/2">
          <mat-icon (click)="closeDialog(false)" class="cross-wizard">
            <img src="/assets/img/icons/ico.16.clear.svg" alt="">
          </mat-icon>
        </div>
      </div>
    </h1>

    <!-- Progress -->
    <div class="progress-indicator" style="padding: 2px 0 8px 0;">
      <div class="meter">
        <p class="meter-filename">
          <b>Progress:</b> {{ progress.correctedRecords }} / {{ progress.totalRecords }} records corrected
          ({{ progress.percentageComplete | number:'1.0-2' }}%)
        </p>
        <span [style.width]="progress.percentageComplete + '%'"
          [style.background-color]="isAllCorrected() ? 'green' : '#053ab2'">
          <b>{{ progress.percentageComplete | number:'1.0-2' }}%</b>
        </span>
      </div>
    </div>

    <div class="sticky_search" style="margin-bottom: 10px;">
      <mat-tab-group [selectedIndex]="getActiveFilterIndex()" (selectedIndexChange)="onFilterTabChange($event)">
        <mat-tab label="All Records ({{ filterCounts.all }})"></mat-tab>
        <mat-tab label="Multiple Matches ({{ filterCounts.multiple }})"></mat-tab>
        <mat-tab label="Single Match ({{ filterCounts.single }})"></mat-tab>
        <mat-tab label="No Matches ({{ filterCounts.none }})"></mat-tab>
      </mat-tab-group>
    </div>

    <mat-dialog-content>
      <!-- Scrollable content area -->
      <div class="wizard-content mat-elevation-z2">
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows
          class="mat-elevation-z1 w-full rounded-md overflow-hidden" id="exportTable">

          <!-- Shared Column Widths -->
          <colgroup>
            <col class="col-expand">
            <col class="col-select">
            <col class="col-cddb">
            <col class="col-input-ndc">
            <col class="col-converted-ndc">
            <col class="col-strength">
            <col class="col-uom">
            <col class="col-match">
            <col class="col-action">
          </colgroup>

          <!-- Expand Column -->
          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)="row.matchCount && row.matchCount > 1 ? toggleRow(row) : null"
                [disabled]="!row.matchCount || row.matchCount <= 1"
                [style.visibility]="row.matchCount && row.matchCount > 1 ? 'visible' : 'hidden'">
                <mat-icon>{{ expandedElement === row ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Customer Drug Name -->
          <ng-container matColumnDef="customerDrugName">
            <th mat-header-cell *matHeaderCellDef>Customer Drug Name</th>
            <td mat-cell *matCellDef="let row">{{ row.customerDrugName }}</td>
          </ng-container>

          <!-- CDDB Drug Name (truncated with tooltip) -->
          <ng-container matColumnDef="cddbDrugName">
            <th mat-header-cell *matHeaderCellDef>CDDB Drug Name</th>
            <td mat-cell *matCellDef="let row">
              {{
              row.status === 'Multiple' ? (row.selectedMatchNdc ?
              (row.selectedCddbDrugName || row.cddbDrugName || '-') : '') : (row.cddbDrugName || '-')
              }}
            </td>
          </ng-container>

          <!-- Strength -->
          <ng-container matColumnDef="strength">
            <th mat-header-cell *matHeaderCellDef>Strength</th>
            <td mat-cell *matCellDef="let row">
              {{
              row.status === 'Multiple'
              ? (row.selectedMatchNdc
              ? (row.selectedStrength || '-')
              : '')
              : (row.strength || '-')
              }}
            </td>
          </ng-container>

          <!-- UOM -->
          <ng-container matColumnDef="uom">
            <th mat-header-cell *matHeaderCellDef>UOM</th>
            <td mat-cell *matCellDef="let row">
              {{
              row.status === 'Multiple'
              ? (row.selectedMatchNdc
              ? (row.selectedUom || '-')
              : '')
              : (row.uom || '-')
              }}
            </td>
          </ng-container>

          <!-- Input NDC -->
          <ng-container matColumnDef="inputNdc">
            <th mat-header-cell *matHeaderCellDef>Input NDC</th>
            <td mat-cell *matCellDef="let row">{{ row.customerNdc }}</td>
          </ng-container>

          <!-- Converted NDC -->
          <ng-container matColumnDef="convertedNdc">
            <th mat-header-cell *matHeaderCellDef>Converted NDC</th>
            <td mat-cell *matCellDef="let row">
              {{ row.status === 'Multiple' ? (row.selectedMatchNdc || '') : (row.selectedMatchNdc || row.customerNdc) }}
            </td>
          </ng-container>

          <!-- Match -->
          <ng-container matColumnDef="match">
            <th mat-header-cell *matHeaderCellDef>Match</th>
            <td mat-cell *matCellDef="let row">
              <div class="flex items-center gap-2">
                <mat-icon [style.color]="getMatchIconColor(row)">{{ getMatchIcon(row) }}</mat-icon>
                <span>{{ getMatchText(row) }}</span>
              </div>
            </td>
          </ng-container>

          <!-- Action -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="action-col">Action</th>
            <td mat-cell *matCellDef="let row" class="action-col action-cell">
              <div class="action-wrapper"
                [class.action-wrapper-disabled]="row.status === 'Multiple' && !row.selectedMatchNdc">
                <mat-select class="action-select" panelClass="action-select-panel"
                  [class.action-select-disabled]="row.status === 'Multiple' && !row.selectedMatchNdc"
                  [(value)]="row.action" (selectionChange)="onActionChange(row, $event.value)"
                  placeholder="Select Action" [disabled]="row.status === 'Multiple' && !row.selectedMatchNdc">
                  <mat-option *ngFor="let option of getActionOptionsForRow(row)" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </div>
            </td>
          </ng-container>

          <!-- Header + rows -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.corrected]="row.isCorrected"
            [class.expanded]="expandedElement === row" [class.non-oral-solid-row]="row.action === 'Non-Oral Solid'">
          </tr>

          <!-- Expanded Row -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
              <div class="element-detail" [@detailExpand]="expandedElement === row ? 'expanded' : 'collapsed'">
                <div class="bg-gray-50" *ngIf="expandedElement === row">
                  <div class="detail-scroll-container detail-align-parent">
                    <table class="w-full detail-table">
                      <colgroup>
                        <col class="col-expand">
                        <col class="col-select">
                        <col class="col-cddb">
                        <col class="col-input-ndc">
                        <col class="col-converted-ndc">
                        <col class ="col-strength">
                        <col class="col-uom">
                        <col class="col-match">
                        <col class="col-action">
                      </colgroup>

                      <thead>
                        <tr>
                          <th></th>
                          <th>Select</th>
                          <th>CDDB Drug Name</th>
                          <th>Input NDC</th>
                          <th>Converted NDC</th>
                          <th>Strength</th>
                          <th>UOM</th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let ndc of row.matchNdc1?.split(','); let i = index"
                          class="cursor-pointer hover:bg-blue-50"
                          [class.bg-green-100]="row.selectedMatchNdc === ndc?.trim()"
                          (click)="onMatchSelect(row, ndc?.trim())">
                          <td></td>
                          <td class="detail-cell detail-selector-offset detail-col-customer">
                            <mat-radio-button [checked]="row.selectedMatchNdc === ndc?.trim()" [value]="ndc?.trim()"
                              color="primary">
                            </mat-radio-button>
                          </td>

                          <td>
                            <span class="truncate-cell" [matTooltip]="row.cddbDrugName?.split(',')[i]?.trim()">
                              {{ row.cddbDrugName?.split(',')[i]?.trim() || row.cddbDrugName}}
                            </span>
                          </td>
                          <td>{{ row.customerNdc }}</td>
                          <td>{{ ndc }}</td>
                          <td>{{ row.strength?.split(',')[i]?.trim() || '-' }}</td>
                          <td>{{ row.uom?.split(',')[i]?.trim() || '-' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

        </table>
      </div>
    </mat-dialog-content>
  </div>

  <!-- Footer -->
  <div class="wizard-footer">
    <div class="footer-left" [class.paginator-disabled]="dataSource.data.length < 10">
      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="10" showFirstLastButtons
        [disabled]="dataSource.data.length < 10" aria-label="Select page of drugs">
      </mat-paginator>
    </div>
    <div class="footer-right">
      <button mat-button class="btn-primary btn-md" (click)="closeDialog(false)" id="Go_Back" type="button"
        aria-label="Go Back">
        Go Back
      </button>

      <button mat-button class="btn-blue btn-md" [disabled]="!isAllCorrected()" (click)="onComplete()" id="Accept"
        type="button" aria-label="Accept">
        Accept
      </button>
    </div>
  </div>
</div>